import styled from 'styled-components';
import BorderLeftTh from '../BorderLeftTh';

const BorderRightTh = styled(BorderLeftTh)`
  border-left: 0;
  border-right: 1px solid #4a6cbb;
`;

export default BorderRightTh;
